/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dispatch } from 'redux'
import { getSettings } from '../../api/api'
import { receiveCompanies, requestCompanies } from '../pages-management/actions'

export const SETTINGS_UPDATE_AVATAR_URL = 'SETTINGS_UPDATE_AVATAR_URL'
export const SETTINGS_UPDATE_FIRST_NAME = 'SETTINGS_UPDATE_FIRST_NAME'
export const SETTINGS_UPDATE_LAST_NAME = 'SETTINGS_UPDATE_LAST_NAME'
export const SETTINGS_UPDATE_EMAIL = 'SETTINGS_UPDATE_EMAIL'
export const SETTINGS_UPDATE_PHONE_NUMBER = 'SETTINGS_UPDATE_PHONE_NUMBER'
export const SETTINGS_UPDATE_VIRTUAL_INFO = 'SETTINGS_UPDATE_VIRTUAL_INFO'
export const SETTINGS_UPDATE_DEFAULT_LOCATION =
  'SETTINGS_UPDATE_DEFAULT_LOCATION'
export const SETTINGS_UPDATE_TIMEZONE = 'SETTINGS_UPDATE_TIMEZONE'
export const REQUEST_SETTINGS = 'REQUEST_SETTINGS'
export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS'

export const requestSettings = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REQUEST_SETTINGS })
    dispatch(requestCompanies())

    const { settings, preferred_times, onboarding } = await getSettings()

    dispatch({
      type: RECEIVE_SETTINGS, settings: {
        ...settings, preferred_times, onboarding,
      },
    })
    dispatch(receiveCompanies(settings.companies))
  }
}

export const settingsUpdateAvatarUrl = (avatar_url: string) => {
  return {
    type: SETTINGS_UPDATE_AVATAR_URL,
    avatar_url,
  }
}

export const settingsUpdateFirstName = (first_name: string) => {
  return {
    type: SETTINGS_UPDATE_FIRST_NAME,
    first_name,
  }
}

export const settingsUpdateLastName = (last_name: string) => {
  return {
    type: SETTINGS_UPDATE_LAST_NAME,
    last_name,
  }
}

export const settingsUpdateEmail = (email: string) => {
  return {
    type: SETTINGS_UPDATE_EMAIL,
    email,
  }
}

export const settingsUpdatePhoneNumber = (phone_number: string) => {
  return {
    type: SETTINGS_UPDATE_PHONE_NUMBER,
    phone_number,
  }
}

export const settingsUpdateVirtualInfo = (virtual_info: string) => {
  return {
    type: SETTINGS_UPDATE_VIRTUAL_INFO,
    virtual_info,
  }
}

export const settingsUpdateDefaultLocation = (default_location: string) => {
  return {
    type: SETTINGS_UPDATE_DEFAULT_LOCATION,
    default_location,
  }
}

export const settingsUpdateTimezone = (timezone: string) => {
  return {
    type: SETTINGS_UPDATE_TIMEZONE,
    timezone,
  }
}
